mutation DeleteMerchOverlay($merchOverlayId: ID!) {
  result: StreamToolsDeleteMerchOverlay(merchOverlayId: $merchOverlayId) {
    id
    deleted
  }
}
